// FILENAME: frontend/src/components/CacheStamp.jsx
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { format, parseISO, differenceInMinutes } from 'date-fns';
import useApi from '../hooks/useApi';

const CacheStamp = ({ sx }) => {
    const { useGetCacheStatus } = useApi();
    const { data, isLoading, isError } = useGetCacheStatus();

    const getChipProps = () => {
        if (isLoading) {
            return { label: 'Loading Cache...', color: 'default' };
        }
        if (isError || !data?.cachedAt) {
            return { label: 'Not Cached', color: 'warning' };
        }

        try {
            const cachedDate = parseISO(data.cachedAt);
            const now = new Date();
            const minutesOld = differenceInMinutes(now, cachedDate);
            
            const formattedTime = format(cachedDate, 'MMM d, h:mm a');
            const label = `Viewing data from: ${formattedTime}`;

            if (minutesOld > 15) {
                return { 
                    label, 
                    color: 'error', 
                    sx: { ...sx, color: 'white' } 
                };
            }

            return { label, color: 'success' };
        } catch (e) {
            return { label: 'Invalid Date', color: 'error' };
        }
    };

    const chipProps = getChipProps();

    return (
        <Tooltip title="Click sync button to update data" arrow>
            <Chip {...chipProps} sx={chipProps.sx || sx} />
        </Tooltip>
    );
};

export default CacheStamp;
